export type Bonus = {
  number: string
  title: string
  /** Short title printed on the code-drawn cover. */
  short: string
  body: string
  accent: string
  /** Optional rendered cover. When empty, a code-drawn cover is shown. */
  cover?: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The 5-Minute Start Guide',
    short: 'The 5-Minute Start Guide',
    body: 'From checkout to your first session in one afternoon: what to open first, which session to run in week one for your kind of group, and what can wait — without reading six volumes cover to cover.',
    accent: 'bg-amber',
    cover: 'https://cdn.magicpatterns.com/uploads/8xKS2QTWyZfp2adSMdwNhy/DPS41_-_Bono_1_-_The_5-Minute_Start_Guide.png',
  },
  {
    number: '02',
    title: 'The Master Session Finder',
    short: 'Master Session Finder',
    body: 'One lookup tool across all six volumes. Pick today’s session in 30 seconds — by goal, by room (students, club, adults or ESL) or by the minutes you have — with the volume and page for all 134 sessions.',
    accent: 'bg-teal',
    cover: 'https://cdn.magicpatterns.com/uploads/f8ZRtJwBorkj5s8yAD6XBT/DPS41_-_Bono_2_-_The_Master_Session_Finder.png',
  },
  {
    number: '03',
    title: 'The Facilitator Cheat-Sheet',
    short: 'Facilitator Cheat-Sheet',
    body: 'How to run any session without friction: timing signals, ready-made transition lines, how to start and how to cut — and exactly what to do when the room goes quiet.',
    accent: 'bg-coral',
    cover: 'https://cdn.magicpatterns.com/uploads/1LYz8jTDGQfGTW9G82Nbxj/DPS41_-_Bono_3_-_The_Facilitator_Cheat-Sheet.png',
  },
  {
    number: '04',
    title: 'Tricky-Room Rescue Cards',
    short: 'Tricky-Room Rescue Cards',
    body: 'Quick fixes for the moments that derail a speaking class: the over-talker, the silent one, the nervous speaker who freezes, the class clown, mixed levels and the dead online room. One fix per card.',
    accent: 'bg-indigo',
    cover: 'https://cdn.magicpatterns.com/uploads/jx17RCtUdT2JFUrdVvzvdi/DPS41_-_Bono_4_-_Tricky-Room_Rescue_Cards.png',
  },
  {
    number: '05',
    title: 'The Online & Hybrid Quick-Guide',
    short: 'Online & Hybrid Quick-Guide',
    body: 'Move any session to video or hybrid in minutes: breakouts, speaking to the camera, timing tweaks and how to get everyone talking without talking over each other.',
    accent: 'bg-amber',
    cover: 'https://cdn.magicpatterns.com/uploads/tigghm2uGDtdbY5tPx1VRz/DPS41_-_Bono_5_-_The_Online__Hybrid_Quick-Guide.png',
  },
]
